module.exports = __webpack_public_path__ + "static/media/serge-kutuzov.850ee512.jpg";